export default "__VITE_ASSET__CyqM7Cl1__"